import { Checkbox } from 'antd';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { haltClickEventPropagation } from '@lib/events';
import { useFeatureFlag } from '@hooks';
import { useIsFollowing } from '@hooks/followers/useIsFollowing';
import { useUpdateFollowing } from '@hooks/followers/useUpdateFollowing';

import React, { useCallback } from 'react';
export interface FollowCheckboxProps {
	sonarObjectId: number;
}

export const FollowCheckbox: React.FC<FollowCheckboxProps> = ({ sonarObjectId }) => {
	const checked = useIsFollowing(sonarObjectId);
	const { follow, unfollow } = useUpdateFollowing([ sonarObjectId ]);
	const enabled = useFeatureFlag(FeatureFlag.Followers);

	const handleOnChange = useCallback(() => {
		if (checked) {
			unfollow();
		} else {
			follow();
		}
	}, [ checked, follow, unfollow ]);

	if (!enabled) {
		return null;
	}

	return (
		<div
			className='follow-checkbox'
			onClick={ haltClickEventPropagation }>
			<Checkbox
				checked={ checked }
				onChange={ handleOnChange } />
		</div>
	);
};
